"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionTypesList = exports.isStreamed = exports.isTimed = exports.isTender = void 0;
var types_1 = require("../types");
var isTender = function (auctionType) { return Number(auctionType) === Number(types_1.AuctionTypeEnum.Tender.toString()); };
exports.isTender = isTender;
var isTimed = function (auctionType) { return Number(auctionType) === Number(types_1.AuctionTypeEnum.Timed.toString()); };
exports.isTimed = isTimed;
var isStreamed = function (auctionType) { return Number(auctionType) === Number(types_1.AuctionTypeEnum.Streamed.toString()); };
exports.isStreamed = isStreamed;
var AuctionTypesList = function () {
    var types = [];
    for (var enumMember in types_1.AuctionTypeEnum) {
        var isValueProperty = parseInt(enumMember, 10) >= 0;
        if (isValueProperty) {
            types.push({
                value: enumMember,
                label: types_1.AuctionTypeEnum[enumMember],
            });
        }
    }
    return types;
};
exports.AuctionTypesList = AuctionTypesList;
